import { Model } from "./Model";

export class Place extends Model {
  static props = {
    id: { type: Number, default: undefined },
    address_1: { type: String, default: "" },
    address_2: { type: String, default: "" },
    city: { type: String, default: "" },
    state: { type: String, default: "" },
    zip: { type: String, default: "" },
    lat: { type: Number },
    lng: { type: Number }
  };

  /**
   * @param parameters  Object
   */
  constructor(parameters) {
    super(Place.props, parameters);
  }

  get streetAddress() {
    if (this.address_2) {
      return `${this.address_1}, ${this.address_2}`;
    }
    return this.address_1 ? this.address_1 : "";
  }

  get cityStateZip() {
    return this.city && this.state && this.zip
      ? `${this.city}, ${this.state} ${this.zip}`
      : "";
  }

  get fullAddress() {
    return this.streetAddress && this.cityStateZip
      ? `${this.streetAddress}, ${this.cityStateZip}`
      : "";
  }
}
